import React from 'react';
import clsx from 'clsx';
import BackgroundImage from 'gatsby-background-image';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { convertToBgImage } from 'gbimage-bridge';
import * as PropTypes from 'prop-types';
import { Grid, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import PageHeader from '$landing-page-raika/components/page-header';
import PageSection from '$landing-page-raika/components/page-section';
import PageWrapper from '$landing-page-raika/components/page-wrapper';

import useStyles from './styles';

const BigHeaderLayout = (props) => {
    const { children, pathname, title, description, secondDescription, backgroundImage, illustrationImage } = props;
    const classes = useStyles();
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <PageWrapper pageMetaData={{ title, description, pathname }}>
            <PageHeader pathname={pathname} />
            <BackgroundImage Tag="section" {...convertToBgImage(getImage(backgroundImage.childImageSharp.gatsbyImageData))}>
                <PageSection className={classes.headerWrapper}>
                    <Grid container alignItems={isMd ? 'center' : 'center'} spacing={2}>
                        {isMd && (
                            <Grid item className={clsx(classes.illustrationWrapper)}>
                                <GatsbyImage image={getImage(illustrationImage)} alt="" />
                            </Grid>
                        )}
                        <Grid item className={classes.headerDescriptionWrapper} xs={12} md={8} lg={8}>
                            <Typography variant="h3" color="textSecondary">
                                {title}
                            </Typography>
                            <Typography variant="body1" color="textSecondary" className={classes.headerDescriptionInfo}>
                                {description}
                            </Typography>
                            {isMd && secondDescription}
                        </Grid>
                        {!isMd && (
                            <Grid item xs={12}>
                                <Grid container wrap="nowrap" direction="row-reverse" alignItems="center">
                                    <Grid item className={clsx(classes.illustrationWrapper)}>
                                        <GatsbyImage image={getImage(illustrationImage)} alt="" />
                                    </Grid>
                                    <Grid item className={classes.secondDescriptionWrapper}>
                                        {secondDescription}
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </PageSection>
            </BackgroundImage>
            <PageSection className={classes.pageContentWrapper}>{children}</PageSection>
        </PageWrapper>
    );
};

BigHeaderLayout.defaultProps = {
    secondDescription: null,
};

BigHeaderLayout.propTypes = {
    children: PropTypes.node.isRequired,
    pathname: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    secondDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.elementType, PropTypes.element]),
    backgroundImage: PropTypes.oneOfType([PropTypes.object]).isRequired,
    illustrationImage: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default BigHeaderLayout;
